import StoredValue from '../stored-value';

export default new StoredValue('PERMISSIONS', []);
